import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls, IShadowFieldPass} from '../../../../interface/form-structure';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DialogDatasetSelectComponent} from '../../../Dialogs/dialog-dataset-select/dialog-dataset-select.component';
import {IDialogDatasetSelectData, IDialogDatasetSelectReturn} from '../../../../interface/dataset-params';
import {FormEventService} from '../../../../services/formEventService';
import {GlobalObjectService} from '../../../../class/global-obj';

@Component({
    selector: 'noos-dataset-select',
    templateUrl: './dataset-select.component.html',
    styleUrls: ['./dataset-select.component.scss']
})
@NoosFormTypeService.register('datasetselect')
export class DatasetSelectComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    shadowFieldValues: IShadowFieldPass[] = [];

    constructor(private dialog: MatDialog, private eventListenerService: FormEventService) {
    }

    ngOnInit() {

    }


    ngAfterViewInit(): void {
        this.shadowFieldValues = GlobalObjectService.getVar('shadow_' + this.formId.toString());
    }

    onOpenDialog2() {
        const dialogConfig = new MatDialogConfig();
        const dialogData: IDialogDatasetSelectData = {
            dataset_id: this.prop.options.dataset_id,
            target_dataset_id: this.datasetId,
            target_field_name: this.prop.name,
            title: this.prop.label,
            shadowFieldValues: this.shadowFieldValues
        };

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '850px';
        dialogConfig.data = dialogData;
        dialogConfig.panelClass = 'formDialog2';

        const dialogRef = this.dialog.open(DialogDatasetSelectComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result: IDialogDatasetSelectReturn) => {
            if (result) {
                this.prop.defaultValue = result.id;
                this.prop.defaultValueTitle = result.title;
                this.eventListenerService.updatedDataSelection({
                    fromComponentId: this.prop.id,
                    fromComponentName: this.prop.name,
                    eventName: this.prop.options.form_selector !== undefined && this.prop.options.form_selector ? 'set_form_id' : 'select',
                    triggerValue: result,
                    formId: this.formId,
                    datasetId: this.datasetId
                });
            }
        });

    }
}
